import { useQuery } from '@tanstack/react-query'
import { produccionDiariaApi } from '@/services/api'
import type { ConsumoAgregadoRow } from '@/types'

/** Lista de componentes agregados del rango. `enabled` para carga perezosa al entrar en la vista. */
export function useConsumosAgregado(desde: string, hasta: string, empresa: string, enabled: boolean) {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['consumos-agregado', desde, hasta, empresa],
    queryFn: () => produccionDiariaApi.getConsumosAgregado({ desde, hasta, empresa: empresa || undefined }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled,
  })
  const rows: ConsumoAgregadoRow[] = (data?.data ?? []) as ConsumoAgregadoRow[]
  return { rows, isLoading, isError, refetch }
}
